import React from "react";
import { Star, Tv, Film } from "lucide-react";

export default function MediaToggle({ value, onChange }) {
  return (
    <div className="flex justify-center my-4">
      <div
        data-testid="media-toggle-container"
        className="bg-[var(--tt-surface-2)] rounded-full p-1 inline-flex border border-[var(--tt-border)]"
      >
        <button
          data-testid="media-toggle-tv"
          onClick={() => onChange("tv")}
          className={`flex items-center gap-2 text-sm font-semibold px-5 py-2 rounded-full transition-all
            ${value === "tv"
              ? "bg-[var(--tt-primary)] text-white shadow-[0_4px_16px_rgba(255,42,109,0.35)]"
              : "text-[var(--tt-text-muted)] hover:text-white"}`}
        >
          <Tv className="w-4 h-4" style={value === "tv" ? undefined : { color: "#06B6D4" }} />
          TV Shows
        </button>
        <button
          data-testid="media-toggle-movies"
          onClick={() => onChange("movie")}
          className={`flex items-center gap-2 text-sm font-semibold px-5 py-2 rounded-full transition-all
            ${value === "movie"
              ? "bg-[var(--tt-primary)] text-white shadow-[0_4px_16px_rgba(255,42,109,0.35)]"
              : "text-[var(--tt-text-muted)] hover:text-white"}`}
        >
          <Film className="w-4 h-4" style={value === "movie" ? undefined : { color: "#FFD700" }} />
          Movies
        </button>
      </div>
    </div>
  );
}

export function StarBadge({ rating }) {
  return (
    <div
      data-testid="movie-card-badge-rating"
      className="absolute top-3 right-3 bg-black/75 backdrop-blur-md text-[#FFD700] text-xs font-bold px-2 py-1 rounded flex items-center gap-1 z-10"
    >
      <Star className="w-3 h-3 fill-[#FFD700]" strokeWidth={0} />
      <span>{(rating || 0).toFixed(1)}</span>
    </div>
  );
}
